import { useState, useEffect } from "react";
import { saveExpenseDetails } from "../Api/Expense";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { GrOrganization } from "react-icons/gr";

const Expense = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [tripIds, setTripIds] = useState([]);
  const [expenseData, setExpenseData] = useState({
    expenseType: "",
    dateofExpense: "",
    merchantName: "",
    amountSpent: "",
    currency: "",
    paymentMethod: "",
    receiptUpload: null,
    descriptionNotes: "",
    TripId: "",
    expenseType2:"",
  });

  useEffect(() => {
    const fetchTripIds = async () => {
      try {
        const res = await axios.get(`${Base_URL}/ExpensesDetails/GetTripId`);
        console.log(res.data);
        setTripIds(res.data);
      } catch (error) {
        console.error("Error fetching trip IDs:", error);
      }
    };
    fetchTripIds();
  }, []);

  const handleChange = (e) => {
    setExpenseData({ ...expenseData, [e.target.name]: e.target.value });
  };

  const handleFileUpload = (e) => {
    setExpenseData({ ...expenseData, receiptUpload: e.target.files[0] });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     await saveExpenseDetails(expenseData);
  //     toast.success(`🦄 Expense Added Successfully`);
  //     setExpenseData({
  //       expenseType: "",
  //       dateofExpense: "",
  //       merchantName: "",
  //       amountSpent: "",
  //       currency: "",
  //       paymentMethod: "",
  //       receiptUpload: null,
  //       descriptionNotes: "",
  //       TripId: "",
  //     });
  //     console.log(expenseData);
  //     navigate("/viewExpense");
  //   } catch (error) {
  //     toast.error(`🦄 Some Error Happened`);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const expensePayload = {
        ...expenseData,
        createdBy: user?.userId ? user.userId.toString() : "",
       organisationId: user?.organisationId // ✅ send createdBy as string
      };

      console.log("Expense Payload:", expensePayload);

      await saveExpenseDetails(expensePayload);
      toast.success("🦄 Expense Added Successfully");

      setExpenseData({
        expenseType: "",
        dateofExpense: "",
        merchantName: "",
        amountSpent: "",
        currency: "",
        paymentMethod: "",
        receiptUpload: null,
        descriptionNotes: "",
        TripId: "",
        expenseType2:""
      });

      navigate("/viewExpense");
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };
return (
  <>
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h2 className="fields-title">Expense Form</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>
                Expense Group ID <span className="text-red"></span>
              </Form.Label>

              <Form.Select
                name="TripId"
                value={expenseData.TripId}
                onChange={handleChange}
              >
                <option value="">Select Expense Group</option>
                {tripIds.map((trip, idx) => (
                  <option key={idx} value={trip.tripId}>
                    {trip.tripName} - {trip.tripId}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Expense Type <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="expenseType"
                  value={expenseData.expenseType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Expense Type</option>
                  <option value="Employee Travel">Employee Travel</option>
                  <option value="Employee Client Visit">Employee Client Visit</option>
                  <option value="Per DM">Per DM</option>
                  <option value="Imprest">Imprest</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Date of Expense <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="dateofExpense"
                  value={expenseData.dateofExpense}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* Expense Type 2 — show only for Imprest */}
            {expenseData.expenseType === "Imprest" && (
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Expense Type 2 <span className="text-red">**</span>
                  </Form.Label>
                  <Form.Select
                    name="expenseType2"
                    value={expenseData.expenseType2 || ""}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="Water">Water</option>
                    <option value="Tea">Tea</option>
                    <option value="Petrol">Petrol</option>
                    <option value="House">House keeping</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row>
            {/* Merchant Name — Optional */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Merchant Name (Optional)</Form.Label>
                <Form.Select
                  name="merchantName"
                  value={expenseData.merchantName}
                  onChange={handleChange}
                >
                  <option value="">Select Merchant Name</option>
                  <option value="MAHESHWARI CAPS PVT. LTD.">MAHESHWARI CAPS PVT. LTD.</option>
                  <option value="RAJ SOLUTIONS">RAJ SOLUTIONS</option>
                  <option value="Krishna Trading Company">Krishna Trading Company</option>
                  <option value="Other">Other</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Amount Spent <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="amountSpent"
                  value={expenseData.amountSpent}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Currency <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="currency"
                  value={expenseData.currency}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Currency</option>
                  <option value="INR">INR</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Payment Method <span className="text-red">**</span>
                </Form.Label>
                <Form.Select
                  name="paymentMethod"
                  value={expenseData.paymentMethod}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Payment Method</option>
                  <option value="Cash">Cash</option>
                  <option value="UPI">UPI</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Payment From Account <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="paymentFromAccount"
                  value={expenseData.paymentFromAccount || ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* Receipt Upload — Optional */}
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Receipt Upload (Optional)</Form.Label>
                <Form.Control
                  type="file"
                  name="receiptUpload"
                  onChange={handleFileUpload}
                  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                />
                <Form.Text className="text-muted">
                  Supported formats: JPG, PNG, PDF, DOC (Max 5MB)
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Description / Notes <span className="text-red">**</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="descriptionNotes"
                  value={expenseData.descriptionNotes}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="fields-btn-container">
            <Button variant="primary" type="submit" className="fields-submit">
              Save Expense
            </Button>
          </div>
        </Form>
      </Container>
    </div>

    {/* Loader Overlay with Sample 14 */}
    {loading && (
      <div className="loading-overlay">
        <Sample14 />
      </div>
    )}
  </>
);
};
export default Expense;
